import { generateReadActionCreator } from '../crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readProductInterestOptions: generateReadActionCreator(routes.API_PRODUCT_INTEREST_OPTIONS, ACTION_NAMES.PRODUCT_INTEREST_OPTIONS)
}
